import React from "react";

/**
 * A utility component that conditionally wraps children with a wrapper component
 * @param {object} props - The component props
 * @param {boolean} [props.condition] - If true, the wrapper will be applied.
 * @param {React.ReactNode} props.wrapper - An instance of a React element that is used to conditionally wrap the children
 * @param {React.ReactNode} [props.children] - The child elements to be conditionally wrapped
 * @returns {React.ReactElement} The wrapped or unwrapped children
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}) => {
  if (condition) {
    const Wrapper = wrapper.type;
    return /*#__PURE__*/_jsx(Wrapper, {
      ...wrapper.props,
      children: children
    });
  }
  return children;
};
ConditionalWrapper.displayName = "ConditionalWrapper";
export default ConditionalWrapper;